import { UseQueryOptions } from 'react-query';
import { dataManagmentHttpClient } from '../../../helpers/http';

export const mapShareRows = ({
  selectedRows,
}: {
  selectedRows: {
    mapRows: {
      id: number;
      typeId: number;
      typeCodeDesc: string;
    };
  }[];
}) =>
  dataManagmentHttpClient.post(
    '/api/datamanagement/submiteditedsharemaprows',
    selectedRows
  );

export const GetShareTabData = ({
  filterBy,
  take = 10,
  page,
  isRefetch,
  sortBy,
  sortDirection,
}: {
  filterBy: 0 | 1 | 2;
  take?: number;
  page?: number;
  isRefetch?: boolean;
  sortBy: string;
  sortDirection: 0 | 1 | 2;
}): UseQueryOptions => ({
  queryKey: [
    'Share-table-filterBy-',
    take,
    filterBy,
    page,
    isRefetch,
    sortBy,
    sortDirection,
  ],
  queryFn: () =>
    dataManagmentHttpClient.get(
      `/api/datamanagement/sharemappingdata?filter=${filterBy}${
        page
          ? `&page=${page}&take=${take}&orderByProperty=${sortBy}&orderBy=${sortDirection}`
          : ''
      }`
    ),
});

export const GetIsShareTabData = ({
  isRefetch,
}: {
  isRefetch: boolean;
}): UseQueryOptions => ({
  queryKey: [`Share-table-${isRefetch ? '-refetched' : ''}`],
  queryFn: () =>
    dataManagmentHttpClient.get('/api/datamanagement/sharemappingdata'),
  refetchInterval: isRefetch ? 10000 : false,
  refetchOnWindowFocus: false,
  cacheTime: 0,
  staleTime: 0,
});

export const GetShareTypesDropdown = (): UseQueryOptions => ({
  queryKey: ['Share-table-dropdown'],
  queryFn: () => dataManagmentHttpClient.get('/api/datamanagement/sharetypes'),
});
